import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonLink, KnowledgeBaseButtons, SearchTitleBox } from './Search.styles';
import { DisabledActionsToggleButton, ActionsToggleButton } from '../../common/buttonsComponents';
import * as searchTypes from '../../../constants/searchTypes';
import { BUTTONS, trackButtonClick } from '../../../analytics/buttonEventAnalytics';
import {
  extractSelectedTicketBusinessDetailsFromState,
  extractSelectedTicketFromState,
  getSearchTypeOfSelectedAction,
  isMacroWizardActiveForBusinessOfSelectedTicket,
  getNumberOfUnreadBusinessAlerts,
  doesBusinessHaveAlerts,
  getSimplrAccountIdOfSelectedTicket,
} from '../../../extractFromState';
import { AVAILABLE } from '../../../constants/expertAvailability';
import {
  getMockOrderManagement,
  getIsSearchButtonsActive,
  showOrdersButton,
  showSearchAllButton,
} from '../../../selectors/tools';
import { setSearchType, clearTools } from '../../../actions/tools/ToolActions';
import { selectOrder, selectOrderingSystem, setOrders } from '../../../actions/tools/OrdersSearchActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ErrorStrings, DISABLED_ALGOLIA_BUTTON_TOOLTIP_TEXT } from '../../../constants/fixedMessages';
import { showErrorMessage } from '../../../util/errorPopupUtil';
import * as SessionAnalyticsService from 'services/SessionAnalyticsService/SessionAnalyticsService';
import { setDecisionTreePath } from '../../../actions/searchActions';
import { ToolTipFixedWidth } from '../../common/tooltips';

class SearchButtons extends Component {
  renderButtons = () => {
    const {
      searchType,
      showButtons,
      mockOrderManagement,
      selectedTicket,
      businessDetail,
      showSearchAll,
      selectOrderingSystem: _selectOrderingSystem,
      setSearchType: _setSearchType,
      selectOrder: _selectOrder,
      showOrdersButton: _showOrdersButton,
      setDecisionTreePath: _setDecisionTreePath,
      setOrders: _setOrders,
    } = this.props;

    const disableLinkOnClick = (e) => {
      e.preventDefault();
    };

    const tooltipMessage = <div>{DISABLED_ALGOLIA_BUTTON_TOOLTIP_TEXT}</div>;

    if (!selectedTicket) {
      showErrorMessage(new Error(ErrorStrings.SELECTED_TICKET_NOT_FOUND), true);

      return null;
    }
    const searchOrderButton = showButtons ? (
      <ActionsToggleButton
        selected={searchType === searchTypes.SEARCH_ORDERS}
        disabled={searchType === searchTypes.SEARCH_ORDERS}
        onClick={() => {
          if (mockOrderManagement && selectedTicket.ticketType === 'ZENDESK') {
            _selectOrderingSystem('mock');
            _selectOrder({
              email: selectedTicket.fromChannel,
              businessDetail,
            });
          } else {
            _setSearchType(searchTypes.SEARCH_ORDERS);
            trackButtonClick(BUTTONS.SEARCH_ORDER);
            SessionAnalyticsService.event('Actions - Search Orders Clicked');
          }
        }}
      >
        SEARCH ORDERS
      </ActionsToggleButton>
    ) : (
      <DisabledActionsToggleButton>SEARCH ORDERS</DisabledActionsToggleButton>
    );

    const searchAllButton = showButtons ? (
      <ActionsToggleButton
        selected={searchType === searchTypes.SEARCH_ALL}
        disabled={searchType === searchTypes.SEARCH_ALL}
        onClick={() => {
          _setSearchType(searchTypes.SEARCH_ALL);
          trackButtonClick(BUTTONS.SEARCH_ALL);
          SessionAnalyticsService.event('Actions - Search All Clicked');
        }}
      >
        SEARCH ALL
      </ActionsToggleButton>
    ) : (
      <DisabledActionsToggleButton>SEARCH ALL</DisabledActionsToggleButton>
    );

    const MacroWizardButton = (
      <ActionsToggleButton
        selected={searchType === searchTypes.MACRO_WIZARD}
        disabled={searchType === searchTypes.MACRO_WIZARD}
        onClick={() => {
          _setSearchType(searchTypes.MACRO_WIZARD);
          _setDecisionTreePath('');
          _setOrders([]);
          trackButtonClick(BUTTONS.MACRO_WIZARD);
          SessionAnalyticsService.event('Actions - Macro Wizard Clicked');
        }}
      >
        GUIDED SEARCH
      </ActionsToggleButton>
    );

    const { knowledgeBaseFolderUrl, responseGuideUrl } = businessDetail;
    const FolderButton = (
      <ToolTipFixedWidth arrow placement="top" content={tooltipMessage}>
        <ButtonLink
          href={knowledgeBaseFolderUrl}
          target="_blank"
          onClick={disableLinkOnClick}
          className={'disabled-link'}
          rel="noopener noreferrer"
        >
          <ActionsToggleButton
            disabled={true}
            onClick={() => {
              trackButtonClick(BUTTONS.COMPANY_INFO);
              SessionAnalyticsService.event('Actions - Knowledge Base Clicked');
            }}
          >
            COMPANY INFO
          </ActionsToggleButton>
        </ButtonLink>
      </ToolTipFixedWidth>
    );
    const ResponseGuideButton = (
      <ToolTipFixedWidth arrow placement="top" content={tooltipMessage}>
        <ButtonLink
          href={'responseGuideUrl'}
          target="_blank"
          rel="noopener noreferrer"
          className={'disabled-link'}
          onClick={disableLinkOnClick}
        >
          <ActionsToggleButton
            disabled={true}
            onClick={() => {
              trackButtonClick(BUTTONS.RESPONSE_GUIDE);
              SessionAnalyticsService.event('Actions - Response Guide Clicked');
            }}
          >
            RESPONSE GUIDE
          </ActionsToggleButton>
        </ButtonLink>
      </ToolTipFixedWidth>
    );

    return (
      <KnowledgeBaseButtons>
        {this.props.isMacroWizardActiveForBusinessOfSelectedTicket && MacroWizardButton}
        {showSearchAll && searchAllButton}
        {_showOrdersButton && searchOrderButton}
        {knowledgeBaseFolderUrl && FolderButton}
        {responseGuideUrl && ResponseGuideButton}
      </KnowledgeBaseButtons>
    );
  };

  render() {
    return (
      <SearchTitleBox>
        <div className="search-orders-title">{this.renderButtons()}</div>
      </SearchTitleBox>
    );
  }
}
SearchButtons.propTypes = {
  selectOrder: PropTypes.func.isRequired,
  setSearchType: PropTypes.func.isRequired,
  showButtons: PropTypes.bool.isRequired,
  mockOrderManagement: PropTypes.bool,
  selectedTicket: PropTypes.object.isRequired,
  businessDetail: PropTypes.object.isRequired,
  selectOrderingSystem: PropTypes.func.isRequired,
  showSearchAll: PropTypes.bool.isRequired,
  showOrdersButton: PropTypes.bool.isRequired,
  isMacroWizardActiveForBusinessOfSelectedTicket: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    searchType: getSearchTypeOfSelectedAction(state),
    showButtons: state.user.isAdmin || state.user.availability === AVAILABLE,
    mockOrderManagement: getMockOrderManagement(state),
    selectedTicket: extractSelectedTicketFromState(state) || {},
    businessDetail: extractSelectedTicketBusinessDetailsFromState(state) || {},
    showSearchAll: showSearchAllButton(state),
    showOrdersButton: showOrdersButton(state),
    searchButtonsActive: getIsSearchButtonsActive(state),
    isMacroWizardActiveForBusinessOfSelectedTicket: isMacroWizardActiveForBusinessOfSelectedTicket(state),
    businessHasAlerts: doesBusinessHaveAlerts(state),
    numberOfUnreadBusinessAlerts: getNumberOfUnreadBusinessAlerts(state),
    selectedSimplrAccountId: getSimplrAccountIdOfSelectedTicket(state),
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setSearchType,
      selectOrder,
      selectOrderingSystem,
      clearTools,
      setDecisionTreePath,
      setOrders,
    },
    dispatch
  );
};

export default SearchButtons = connect(mapStateToProps, mapDispatchToProps)(SearchButtons);
